import { useQuery } from "@tanstack/react-query";
import {
  getOpportunityDashboard,
  type OpportunityDashboardResponse,
} from "../api";

export function useOpportunityDashboard(selectedMonth: string) {
  return useQuery<OpportunityDashboardResponse>({
    queryKey: ["opportunity-dashboard", selectedMonth],
    queryFn: () => getOpportunityDashboard(selectedMonth),
    enabled: Boolean(selectedMonth),
    refetchOnWindowFocus: false,
  });
}
